import { css } from 'styled-components'

/**
 * Highlight styling for the `is-keyboard-focused` row class emitted by
 * `useTableKeyboardNavigation`'s `getRowClassName`. Mix into an antd
 * `Table`'s styled-components wrapper.
 */
export const keyboardFocusedRowCss = css`
  .ant-table-tbody > .ant-table-row.is-keyboard-focused > td,
  .ant-table-tbody
    > .ant-table-row.is-keyboard-focused
    > td.ant-table-cell-fix-left {
    background-color: #f2f6fd !important;
  }

  .ant-table-tbody > .ant-table-row:focus-visible > td,
  .ant-table-tbody > .ant-table-row.is-keyboard-focused > td {
    box-shadow:
      inset 0 2px 0 #1859af,
      inset 0 -2px 0 #1859af;
  }

  .ant-table-tbody > .ant-table-row:focus-visible > td:first-child,
  .ant-table-tbody > .ant-table-row.is-keyboard-focused > td:first-child {
    box-shadow:
      inset 0 2px 0 #1859af,
      inset 0 -2px 0 #1859af,
      inset 2px 0 0 #1859af;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  .ant-table-tbody > .ant-table-row:focus-visible > td:last-child,
  .ant-table-tbody > .ant-table-row.is-keyboard-focused > td:last-child {
    box-shadow:
      inset 0 2px 0 #1859af,
      inset 0 -2px 0 #1859af,
      inset -2px 0 0 #1859af;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
`
